import { Feature, FeatureName, useFeatures, useIsFeatureEnabled, useUpdateFeature } from '@gripp/shared-logic';
import { DataGrid, SlideLayout, Toggle } from '@gripp/shared-ui';
import { useQueryClient } from '@tanstack/react-query';
import { createColumnHelper } from '@tanstack/react-table';
import React, { useEffect, useState } from 'react';
import { Features as FeaturesOld } from './features-old';

export const Features = () => {
  const isCropCircleRedesignEnabled = useIsFeatureEnabled(FeatureName.CropCircleRedesign);

  if (isCropCircleRedesignEnabled) {
    const leftColumn = {
      title: 'features.title',
      mainComponent: <FeaturesBase />
    };
    
    return (
      <SlideLayout 
        leftColumn={leftColumn}
      />
    );
  }

  return <FeaturesOld />;
};

const FeaturesBase = () => {
  const [dataRows, setDataRows] = useState(undefined);

  const { data, isLoading } = useFeatures();
  const { mutate: updateFeature } = useUpdateFeature();

  const queryClient = useQueryClient();

  const setFeatureEnabled = (enabled: boolean, feature: Feature) => {
    const input = {
      id: feature.id,
      enabled: enabled,
    };

    updateFeature({ input: input });
  };

  const columnHelper = createColumnHelper();
  const columns = [
    columnHelper.accessor('name', {
      cell: (info) => info.getValue(),
      header: () => 'Name',
    }),
    columnHelper.accessor('status', {
      cell: (info) => {
        const feature = info.row.original as Feature;
        const currentFeature = data.items.filter((f: Feature) => f.id === feature.id)[0];
        const isEnabled = currentFeature?.enabled ?? false;

        return (
          <Toggle
            value={isEnabled}
            onValueChange={(value) => setFeatureEnabled(value, feature)}
            size="small"
          />
        );
      },
      header: () => 'Enabled',
    }),
    columnHelper.accessor('description', {
      cell: (info) => info.getValue(),
      header: () => 'Description',
    }),
  ];

  useEffect(() => {
    if (data) {
      setDataRows(data.items);
    }
  }, [data]);

  return dataRows && !isLoading ? (
    <DataGrid data={dataRows} columns={columns as any} isLoading={isLoading} />
  ) : (
    <h1>Loading...</h1>
  );
};
